import { forwardRef, Ref, type SVGProps } from 'react';

const SvgInstagramIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <rect
      width={18}
      height={18}
      x={3}
      y={3}
      stroke="currentColor"
      strokeWidth={1.5}
      rx={5}
    />
    <circle cx={12} cy={12} r={4} stroke="currentColor" strokeWidth={1.5} />
    <circle cx={17.5} cy={6.5} r={1} fill="currentColor" />
  </svg>
);
const ForwardRef = forwardRef(SvgInstagramIcon);
export default ForwardRef;
